<template>
  <div class="w-100">
    <el-form-item
      :label="label"
      class="pr-2"
    >
      <el-radio-group v-model="form.uads_id" class="w-100" @change="chooseAddress">
        <el-radio
          v-for="address in list"
          :key="address.uads_id"
          :label="address.uads_id"
          border
          class="col-12 mb-2 mx-1"
          :style="{ minHeight: '3rem', padding: '2rem 1rem' }"
        >
          <div class="d-flex justify-content-between">
            <div>
              <span v-if="address.uads_type == 'address'" class="badge badge-info"> {{ t("orders.shippingAddress") }} </span>
              <span v-else-if="address.uads_type == 'cvs_pcsc'" class="badge badge-info"> {{ t("orders.shop711") }} </span>
              <span v-else-if="address.uads_type == 'cvs_family'" class="badge badge-info"> {{ t("orders.shopFami") }} </span>
              <span v-else-if="address.uads_type == 'cvs_hilife'" class="badge badge-info"> {{ t("orders.shopHilife") }} </span>
              <span v-else-if="address.uads_type == 'cvs_okmart'" class="badge badge-info"> {{ t("orders.shopOkmart") }} </span>
              <span v-else class="badge badge-info"> {{ address.uads_type }} </span>

              <span v-if="address.uads_type == 'address'" style="white-space: break-spaces">
              [{{ address.postcode }}] {{ address.province }}{{ address.city }}{{ address.address }}
              </span>
              <span v-else-if="address.uads_type == 'cvs_pcsc' || address.uads_type == 'cvs_family'" style="white-space: break-spaces">
              [{{ address.shop.shop_name }}] {{ address.shop.shop_address_full }}
              </span>
            </div>
            <!-- 動作(右上角) -->
            <div v-if="(address.uads_id != form.uads_id)">
              <i class="bi bi-x-circle-fill product-item-tool__icon" @click="(e) => handleRemove(e, address.uads_id)"></i>
            </div>
          </div>
        </el-radio>
        <el-radio :label="-1" border class="col-12 mb-2 mx-1" :style="{ minHeight: '3rem', padding: '2rem 1rem' }">
          {{ type == "address" ? "其他地址" : "其他門市" }}
        </el-radio>
      </el-radio-group>
    </el-form-item>
  </div>
</template>

<script setup>
import { reactive, onMounted, ref, computed } from 'vue'
import { useI18n } from "vue-i18n"
import { notificationErrors } from "../../utils"
import { _api_getAddresses, _api_postAddress, _api_deleteAddress, _api_setDefaultAddress } from "../../api/index.js";
import { useVModel } from '@vueuse/core'

const props = defineProps({
  type: {
    type: String,
    default: null,
  },
  modelValue: Object,
})
const emit = defineEmits(['update:modelValue', 'ok'])
const { t, n, locale } = useI18n()

const form = useVModel(props, 'modelValue', emit)
const list = ref([])

const label = computed(() => {
  if (props.type == "cvs_pcsc") {
    return t('orders.shop711')
  } else if (props.type == "cvs_family") {
    return t('orders.shopFami')
  } else if (props.type == "cvs_hilife") {
    return t('orders.shopHilife')
  } else if (props.type == "cvs_okmart") {
    return t('orders.shopOkmart')
  }
  return t('orders.shippingAddress')
})
const getAccountAddresses = async () => {
  window.fullPageLoading("show")
  try {
    const resp = await _api_getAddresses({ uads_type: props.type })
    list.value = resp.data
    if (!form.value.isOuterIsland) {
      // 不允許外島
      list.value = list.value.filter((el) => !el.is_outer_island)
    }
    // console.log("getAccountAddresses: ", list.value)
    const defaultItem = list.value.find((el) => el.is_default && !el.is_outer_island)
    if (defaultItem) {
      form.value.uads_id = defaultItem.uads_id
      chooseAddress(defaultItem.uads_id)
    }
  } catch (err) {
    notificationErrors(err)
  } finally {
    window.fullPageLoading("hide")
  }
}

const chooseAddress = (val) => {
  if (val === -1) {
    emit('ok')
    return
  }
  const choose = list.value.find((address) => address.uads_id == val);
  emit('ok', choose)
}

const handleCreate = async (data) => {
  // console.log("isCreate: ", isCreate.value)
  if (!props.type || !data) {
    return
  }
  window.fullPageLoading("show")
  try {
    const address = reactive({
      uads_type: props.type,
      to_name: data.to_name,
      to_mobile: data.to_mobile,
      to_email: data.to_email,
      country: data.country,
      is_default: true,
    })
    if (props.type == "address") {
      address["province"] = data.province
      address["city"] = data.city
      address["region"] = data.region
      address["postal_code"] = data.postal_code
      address["address"] = data.address
    } else if (props.type == "cvs_family") {
      address["cvs_family_shop_id"] = data.cvs_family_shop_id
    } else if (props.type == "cvs_pcsc") {
      address["cvs_711_shop_id"] = data.cvs_711_shop_id
    }
    // console.log("handleCreate: ", address)
    const resp = await _api_postAddress(address)
  } catch (err) {
    notificationErrors(err)
  } finally {
    window.fullPageLoading("hide")
  }
}

const handleDefault = (uads_id) => {
  // 結帳時才會觸發，強制將選用的地址設為預設
  try {
    _api_setDefaultAddress(uads_id)
  } catch (err) {
    notificationErrors(err)
  }
}

const handleRemove = async (event, uads_id) => {
  event.preventDefault()
  window.fullPageLoading("show")
  try {
    await _api_deleteAddress(uads_id)
    list.value = list.value.filter((el) => el.uads_id != uads_id)
  } catch (err) {
    notificationErrors(err)
  } finally {
    window.fullPageLoading("hide")
  }
}

onMounted(() => {
  getAccountAddresses()
})

defineExpose({ handleCreate, handleDefault })
</script>
<style>
.el-radio__label {
  width: 100%;
}
</style>